import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
const AddCouponModal = ({
    open,
    onClose,
    userUid,
    onSuccess,
    isEdit,
    editData,
}) => {

    const initialState = {
        coupon_code: "",
        discount_percentage: "",
        minimum_order_amount: "",
        maximum_discount_amount: "",
        usage_limit: 1,
        valid_from: "",
        valid_until: "",
    };

    const [formData, setFormData] = useState(initialState);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const generateCouponCode = () => {
        const today = new Date();
        const date =
            today.getFullYear().toString() +
            String(today.getMonth() + 1).padStart(2, "0") +
            String(today.getDate()).padStart(2, "0");

        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

        let random = "";

        for (let i = 0; i < 6; i++) {
            random += chars.charAt(
                Math.floor(Math.random() * chars.length)
            );
        }

        setFormData((prev) => ({
            ...prev,
            coupon_code: `MMQ-${date}-${random}`,
        }));
    };

    useEffect(() => {

        if (!open) return;

        if (isEdit && editData) {

            setFormData({
                coupon_code: editData.coupon_code || "",
                discount_percentage:
                    editData.discount_percentage || "",
                minimum_order_amount:
                    editData.minimum_order_amount || "",
                maximum_discount_amount:
                    editData.maximum_discount_amount || "",
                usage_limit:
                    editData.usage_limit || 1,
                valid_from: editData.valid_from
                    ? editData.valid_from.slice(0, 16)
                    : "",
                valid_until: editData.valid_until
                    ? editData.valid_until.slice(0, 16)
                    : "",
            });

        } else {

            setFormData(initialState);

            generateCouponCode();

        }

    }, [open, isEdit, editData]);
    const submitCoupon = async () => {

        if (
            !formData.coupon_code.trim() ||
            !formData.discount_percentage ||
            !formData.valid_from ||
            !formData.valid_until
        ) {
            toast.error("Please fill all required fields.");
            return;
        }

        if (
            Number(formData.discount_percentage) <= 0 ||
            Number(formData.discount_percentage) > 100
        ) {
            toast.error("Discount percentage must be between 1 and 100.");
            return;
        }

        if (
            Number(formData.minimum_order_amount) < 0
        ) {
            toast.error("Minimum order amount cannot be negative.");
            return;
        }

        if (
            formData.maximum_discount_amount &&
            Number(formData.maximum_discount_amount) < 0
        ) {
            toast.error("Maximum discount cannot be negative.");
            return;
        }

        if (
            new Date(formData.valid_until) <=
            new Date(formData.valid_from)
        ) {
            toast.error("Valid Until must be greater than Valid From.");
            return;
        }

        try {

            setLoading(true);

            const token = localStorage.getItem("adminAuth");

            const url = isEdit
                ? `${process.env.REACT_APP_BASEURL}/admin/admin_update_user_coupon/`
                : `${process.env.REACT_APP_BASEURL}/admin/admin_create_user_coupon/`;

            const payload = {
                uid: userUid,
                ...formData,
            };

            if (isEdit) {
                payload.coupon_uid = editData.uid;
            }

            const response = await fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    Authorization: `Token ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const result = await response.json();

            if (response.ok) {

                toast.success( result.msg || (isEdit  ? "Coupon updated successfully." : "Coupon created successfully.") );
                setFormData(initialState);
                onSuccess();

            } else {

                toast.error(
                    result.msg || "Something went wrong."
                );

            }

        } catch (err) {

            console.log(err);

            toast.error(
                isEdit
                    ? "Failed to update coupon."
                    : "Failed to create coupon."
            );

        } finally {

            setLoading(false);

        }

    };
    if (!open) return null;

    return (
        <div className="fixed inset-0 bg-black/40 z-50 flex justify-center items-center p-5">
            <div className="bg-white rounded-xl shadow-xl w-full max-w-3xl">

                <div className="border-b px-6 py-4 flex justify-between items-center">

                    <h2 className="text-2xl font-bold">
                        {isEdit ? "Edit Individual Coupon" : "Add Individual Coupon"}
                    </h2>

                    <button
                        onClick={() => {
                            setFormData(initialState);
                            onClose();
                        }}
                        className="text-2xl"
                    >
                        ×
                    </button>

                </div>

                <div className="p-6">

                    <div className="grid grid-cols-2 gap-5">

                        <div>

                            <label className="font-medium">
                                Coupon Code *
                            </label>

                            <div className="flex gap-3 mt-2">

                                <input
                                    type="text"
                                    name="coupon_code"
                                    value={formData.coupon_code}
                                    onChange={handleChange}
                                    className="border rounded-lg p-3 flex-1"
                                />

                                <button
                                    type="button"
                                    onClick={generateCouponCode}
                                    disabled={isEdit}
                                    className={`px-5 rounded-lg whitespace-nowrap text-white ${isEdit
                                            ? "bg-gray-400 cursor-not-allowed"
                                            : "bg-gray-800 hover:bg-black"
                                        }`}
                                >
                                    Generate
                                </button>

                            </div>

                        </div>

                        <div>

                            <label className="font-medium">
                                Discount (%)
                            </label>

                            <input
                                type="number"
                                name="discount_percentage"
                                value={formData.discount_percentage}
                                onChange={handleChange}
                                className="border rounded-lg p-3 mt-2 w-full"
                            />

                        </div>

                        <div>

                            <label className="font-medium">
                                Minimum Order
                            </label>

                            <input
                                type="number"
                                name="minimum_order_amount"
                                value={formData.minimum_order_amount}
                                onChange={handleChange}
                                className="border rounded-lg p-3 mt-2 w-full"
                            />

                        </div>

                        <div>

                            <label className="font-medium">
                                Maximum Discount
                            </label>

                            <input
                                type="number"
                                name="maximum_discount_amount"
                                value={formData.maximum_discount_amount}
                                onChange={handleChange}
                                className="border rounded-lg p-3 mt-2 w-full"
                            />

                        </div>

                        <div>

                            <label className="font-medium">
                                Usage Limit
                            </label>

                            <input
                                type="number"
                                name="usage_limit"
                                value={formData.usage_limit}
                                onChange={handleChange}
                                className="border rounded-lg p-3 mt-2 w-full"
                            />

                        </div>

                        <div />

                        <div>

                            <label className="font-medium">
                                Valid From
                            </label>

                            <input
                                type="datetime-local"
                                name="valid_from"
                                value={formData.valid_from}
                                onChange={handleChange}
                                className="border rounded-lg p-3 mt-2 w-full"
                            />

                        </div>

                        <div>

                            <label className="font-medium">
                                Valid Until
                            </label>

                            <input
                                type="datetime-local"
                                name="valid_until"
                                value={formData.valid_until}
                                onChange={handleChange}
                                className="border rounded-lg p-3 mt-2 w-full"
                            />

                        </div>

                    </div>

                </div>

                <div className="border-t p-5 flex justify-end gap-3">

                    <button
                        onClick={() => {
                            setFormData(initialState);
                            onClose();
                        }}
                        className="px-5 py-2 rounded-lg border"
                    >
                        Cancel
                    </button>

                    <button
                        onClick={submitCoupon}
                        disabled={loading}
                        className="bg-teal-600 hover:bg-teal-700 disabled:bg-gray-400 text-white px-6 py-2 rounded-lg"
                    >
                        {loading
                            ? (isEdit ? "Updating..." : "Creating...")
                            : (isEdit ? "Update Coupon" : "Create Coupon")}
                    </button>

                </div>

            </div>
        </div>
    );

};

export default AddCouponModal;